import React, { useEffect, useState } from 'react';
import { MinusCircleOutlined, PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Form, Input, Row, Select, Space, Radio } from 'antd';
import accountService from '../../api/account.service';
import { ADD_MODE, SUCCESS_STATUS } from '../../utility/Constants';
import TextArea from 'antd/lib/input/TextArea';
import commonUtility from '../../utility/Utils';
import ProgrammeService from '../../api/programme.service';
const { Option } = Select;




const purchaseCardView = {
    background: "#fbfbfb",
    backgroundColor: "fbfbfb",
    padding: "7px 10px",
    paddingTop: "15px",
    borderRadius: '12px',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    marginBottom: '10px',
    border: '1px solid #ddd'

};

const BTATournamentDetailView = (props) => {


    const [isGST, setisGST] = useState(false);
    const [descriptionList, setDescriptionList] = useState([]);
    const [accountList, setAccountList] = useState([]);
    const [cgstList, setCgstList] = useState([]);
    const [sgstList, setSgstList] = useState([]);
    const [igstList, setIgstList] = useState([]);
    const [tournamentList, setTournamentList] = useState([]);
    const [isTournamentSelectedList, setIsTournamentSelectedList] = useState([]);
    const [gstOrNongst, setgstOrNongst] = useState("GST");
    const [isGstNonGstDisabled, setIsGstNonGstDisabled] = useState(false);



    useEffect(() => {
        accountService.accountListExceptCD().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                //setAccountList(res.data.response_data);
                setDescriptionList(res.data.response_data);
            }

        });
    }, []);





    useEffect(() => {
        setTournamentList([]);
        ProgrammeService.tournamentList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setTournamentList(res.data.response_data);
            }
        });
    }, []);


    useEffect(() => {

        if (props.tournamentDetailList.length > 0) {

           console.log(props.form.getFieldValue('is_gst_bill'));
            props.form.setFieldsValue({
                general_receipt_detail: props.tournamentDetailList,
            });
            const updatedSelection = [...isTournamentSelectedList];
            props.tournamentDetailList.map((item, index) => {
                // console.log('fdf',item);               
                updatedSelection[index] = item.is_tournament === 'Y';  
            })
            setIsTournamentSelectedList(updatedSelection);

            const isGstBill = props.form.getFieldValue('is_gst_bill') === "Y";

            props.form.setFieldsValue({
                gst_nongst: isGstBill ? "GST" : "NONGST"
            });            
            setisGST(!isGstBill);
            setIsGstNonGstDisabled(true);

        }
        else {

            props.form.setFieldsValue({
                general_receipt_detail: [
                    {
                        is_tournament: '',
                        cr_ac_id: '',
                        amount: '',
                        discount: 0,
                        taxable_amount: 0,
                        cgst_id: '',
                        cgst_rate_text: '',
                        cgst_amount: 0,
                        cgst_rate: 0,
                        sgst_id: '',
                        sgst_rate: 0,
                        sgst_rate_text: '',
                        sgst_amount: 0,
                        total_gst_amount: 0,
                        net_amount: 0,
                        is_waiver: 'N',
                        tournament_id: undefined
                    }
                ],
            });
         
        }

    }, [props.tournamentDetailList]);

    useEffect(() => {

        console.log('props.tournamentDetailList', props.tournamentDetailList);

        // Initialize isTournamentSelectedList based on the number of rows
        const initialSelection = Array(props.tournamentDetailList.length).fill(false);
        setIsTournamentSelectedList(initialSelection);
    }, []);



    const handleIsTournamentChange = (value, event, index) => {
        /* console.log('value',value);
         console.log('event',event);
         console.log('index',index);
         */

        const updatedSelection = [...isTournamentSelectedList];
        updatedSelection[index] = value === 'Y';
        setIsTournamentSelectedList(updatedSelection);

        if (value === 'N') {
            props.form.setFields([
                {
                    name: ['general_receipt_detail', index, "tournament_id"],
                    value: undefined,
                },
            ]);
        }
    };

    const handleAmount = (event, index) => {

        const formDetailKeyName = 'general_receipt_detail';

        const amount = props.form.getFieldValue([
            formDetailKeyName,
            index,
            "amount",
        ]);

        // console.log('value', amount);
        props.form.setFields([
            {
                name: ['general_receipt_detail', index, "taxable_amount"],
                value: amount,
            },
        ]);

        const cgst_id = props.form.getFieldValue(["general_receipt_detail", index, "cgst_id"]) != undefined ? props.form.getFieldValue(["general_receipt_detail", index, "cgst_id"]) : "";
        const sgst_id = props.form.getFieldValue(["general_receipt_detail", index, "sgst_id"]) != undefined ? props.form.getFieldValue(["general_receipt_detail", index, "sgst_id"]) : "";

        const cgst_rate = props.form.getFieldValue(["general_receipt_detail", index, "cgst_rate"]) != undefined ? props.form.getFieldValue(["general_receipt_detail", index, "cgst_rate"]) : 0;
        const sgst_rate = props.form.getFieldValue(["general_receipt_detail", index, "sgst_rate"]) != undefined ? props.form.getFieldValue(["general_receipt_detail", index, "sgst_rate"]) : 0;


        onGSTChange(index, { "type": "CGST", "value": cgst_id, "rate": cgst_rate }, index);
        onGSTChange(index, { "type": "SGST", "value": sgst_id, "rate": sgst_rate }, index);

    };
    useEffect(() => {
        const data = {
            formdata: { gstType: "CGST", usedfor: "O" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setCgstList(res.data.response_data);
            }
        });
    }, []);

    useEffect(() => {
        const data = {
            formdata: { gstType: "SGST", usedfor: "O" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setSgstList(res.data.response_data);
            }
        });
    }, []);

    const onGSTChange = (v, e, index) => {

        const gst_type = e.type;
        // const gst_id = e.value;
        const gst_rate = e.rate;

        const amount = props.form.getFieldValue(["general_receipt_detail", index, "amount",]) > 0 ? props.form.getFieldValue(["general_receipt_detail", index, "amount",]) : 0;
        let gst_amount = (amount * gst_rate) / 100;
        // console.log(gst_type);
        // console.log(gst_amount);
        // resetGst(index, gst_type, gst_id);

        if (gst_type == "CGST") {
            props.form.setFields([
                {
                    name: ["general_receipt_detail", index, "cgst_amount"],
                    value: gst_amount,
                }
            ]);
            props.form.setFields([
                {
                    name: ["general_receipt_detail", index, "cgst_rate"],
                    value: gst_rate,
                }
            ]);
        }
        else if (gst_type == "SGST") {
            props.form.setFields([
                {
                    name: ["general_receipt_detail", index, "sgst_amount"],
                    value: gst_amount,
                }
            ]);
            props.form.setFields([
                {
                    name: ["general_receipt_detail", index, "sgst_rate"],
                    value: gst_rate,
                }
            ]);
        }

        onCalculateBlockPayable(index);
    };


    const onCalculateBlockPayable = (index) => {

        let total_amount_with_gst = 0;
        let total_gst = 0;

        const amount = props.form.getFieldValue(["general_receipt_detail", index, "amount",]) > 0 ? props.form.getFieldValue(["general_receipt_detail", index, "amount",]) : 0;
        const cgst_amount = props.form.getFieldValue(["general_receipt_detail", index, "cgst_amount",]) > 0 ? props.form.getFieldValue(["general_receipt_detail", index, "cgst_amount",]) : 0;
        const sgst_amount = props.form.getFieldValue(["general_receipt_detail", index, "sgst_amount",]) > 0 ? props.form.getFieldValue(["general_receipt_detail", index, "sgst_amount",]) : 0;

        total_gst = parseFloat(cgst_amount) + parseFloat(sgst_amount);
        total_amount_with_gst = total_gst + parseFloat(amount);


        props.form.setFields([
            {
                name: ["general_receipt_detail", index, "net_amount"],
                value: total_amount_with_gst.toFixed(2),
            }
        ]);

        props.onFormCalculation();

    }


    // const resetGst = (index, type, id) => {

    //     if (commonUtility.sanitizeValue(id) > 0) {
    //         if(type == "CGST"){
    //             props.form.setFields([{ name: ["general_receipt_detail", index, "cgst_amount"], value: 0, }]);
    //             props.form.setFields([{ name: ["general_receipt_detail", index, "cgst_rate"], value: 0, }]);
    //             // props.form.setFields([{ name: ["general_receipt_detail", index, "cgst_id"], value: "", }]);
    //         }else{
    //             props.form.setFields([{ name: ["general_receipt_detail", index, "sgst_amount"], value: 0, }]);
    //             props.form.setFields([{ name: ["general_receipt_detail", index, "sgst_rate"], value: 0, }]);
    //             // props.form.setFields([{ name: ["general_receipt_detail", index, "sgst_id"], value: "", }]);
    //         }          


    //     }

    // }


    const onChangeGstNongst = (event) => {
       // console.log("props.form",props.form.getFieldsValue())
        let fields = props.form.getFieldsValue();
      //  console.log("fields",fields);
       // console.log("fields",fields.general_receipt_detail.length);
        const value = event.target.value;
        if (value === "GST") {
            setisGST(false); // Set the state to false for GST
            setgstOrNongst('GST'); 
            props.form.setFieldsValue({ is_gst_bill: "Y" });           
        } else {
            setisGST(true); // Set the state to true for NONGST
            setgstOrNongst('NONGST'); // Update the state for the selected option
            const length = fields.general_receipt_detail.length;
            for (let index = 0; index < length; index++) {
                // const element = array[index];
                props.form.setFields([{ name: ["general_receipt_detail", index, "cgst_amount"], value: "", }]);
                props.form.setFields([{ name: ["general_receipt_detail", index, "cgst_rate"], value: "", }]);
                props.form.setFields([{ name: ["general_receipt_detail", index, "cgst_id"], value: "", }]);
                props.form.setFields([{ name: ["general_receipt_detail", index, "sgst_amount"], value: "", }]);
                props.form.setFields([{ name: ["general_receipt_detail", index, "sgst_rate"], value: "", }]);
                props.form.setFields([{ name: ["general_receipt_detail", index, "sgst_id"], value: "", }]);
                props.form.setFields([{ name: ["general_receipt_detail", index, "cgst_amount"], value: "", }]);
                props.form.setFieldsValue({ is_gst_bill: "N" });               
            }
          
            props.onFormCalculation();
        }
    };





    return (
        <div>

            {/* <h4 style={{ marginTop: '10px' }}>Tournament Details</h4> */}
            <h4 style={{ marginTop: '10px' }}>Receipt Type</h4>
            <Divider style={{ margin: 2 }} />

            <Col className="gutter-row" xs={24} xl={24} style={{ marginBottom: 3 }}>
                <Form.Item name="gst_nongst" label="">
                    <Radio.Group                        
                        buttonStyle="solid"
                        name="gst_nongst_radio"
                        onChange={(e) => onChangeGstNongst(e)}
                        defaultValue={gstOrNongst}
                        disabled={isGstNonGstDisabled}
                    >
                        <Radio.Button value="GST">GST</Radio.Button>
                        <Radio.Button value="NONGST">NON GST</Radio.Button>
                    </Radio.Group>
                </Form.Item>
            </Col>
            
            <Form.List name="general_receipt_detail" >
                {(fields, { add, remove }) => (
                    <>
                        {
                            //fields.map((field, index) => (
                            fields.map(({ key, name, ...restField }, index) => (

                                <div key={key}>
                                    <Row gutter={20} >

                                        <Col xs={24} xl={3} >
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'is_tournament']}
                                                label="Tournament(Yes/No)">
                                                <Select className="text-left" allowClear={false}
                                                    onSelect={(value, event) => handleIsTournamentChange(value, event, index)}
                                                >
                                                    <Option value="Y">Yes</Option>
                                                    <Option value="N">No</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={6}>

                                            <Form.Item
                                                {...restField}
                                                label="Ledger"
                                                name={[name, 'cr_ac_id']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Ledger Required',
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left"
                                                    showSearch
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        // option.children.includes(input)
                                                        option.children.toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.children
                                                            .toLowerCase()
                                                            .localeCompare(optionB.children.toLowerCase())
                                                    }
                                                    placement="bottomLeft"
                                                    allowClear={true}


                                                >
                                                    <Option >Select</Option>
                                                    {descriptionList.length > 0
                                                        ? descriptionList.map((desc_list) => (
                                                            <Option key={desc_list.account_master_id} value={desc_list.account_master_id} >{desc_list.account_name}</Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>


                                        <Col xs={24} xl={3}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "amount"]}
                                                label="Amount"

                                            >
                                                <Input placeholder="" readOnly={false}

                                                    onChange={(event) => handleAmount(event, index)}
                                                />
                                            </Form.Item>
                                        </Col>

                                        {/* start by anil on 12-02-2024 */}

                                        <Col xs={24} xl={3} hidden={isGST}>
                                            <Form.Item name={[name, "cgst_id"]} label="CGST">
                                                <Select className="text-left" allowClear={true} onChange={(value, event) => onGSTChange(value, event, index)} type="CGST" defaultValue={""} >
                                                    {cgstList.length > 0
                                                        ? cgstList.map((cgst_list) => (
                                                            <Option
                                                                key={cgst_list.id}
                                                                value={cgst_list.id}
                                                                rate={cgst_list.rate}
                                                                type="CGST"
                                                            >
                                                                {cgst_list.gstDescription}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>

                                            <Form.Item name={[name, "cgst_rate"]} hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>

                                        </Col>

                                        <Col xs={24} xl={3} hidden={isGST}>
                                            <Form.Item name={[name, "cgst_amount"]} label="CGST Amt.">
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                        </Col>


                                        <Col xs={24} xl={3} hidden={isGST}>
                                            <Form.Item name={[name, "sgst_id"]} label="SGST">
                                                <Select className="text-left" allowClear={true} onChange={(value, event) => onGSTChange(value, event, index)} type="SGST" defaultValue={""}
                                                >
                                                    {sgstList.length > 0
                                                        ? sgstList.map((sgst_list) => (
                                                            <Option
                                                                key={sgst_list.id}
                                                                value={sgst_list.id}
                                                                rate={sgst_list.rate}
                                                                type="SGST"
                                                            >
                                                                {sgst_list.gstDescription}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                            <Form.Item name={[name, "sgst_rate"]} hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={3} hidden={isGST}>
                                            <Form.Item name={[name, "sgst_amount"]} label="SGST Amt.">
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={3} hidden={true}>
                                            <Form.Item name={[name, "total_gst_amount"]} label="Total GST">
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={3} hidden={isGST}>
                                            <Form.Item name={[name, "net_amount"]} label="Net Amount">
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>

                                        </Col>

                                        {/* end by anil on 12-02-2024 */}


                                        <Col xs={24} xl={2} hidden={true}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "discount"]}
                                                label="Discount"
                                            >
                                                <Input
                                                    placeholder=""


                                                />
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "taxable_amount"]}
                                                label="Taxable"
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                            {/* <Form.Item
                                                {...restField}
                                                name={[name, "cgst_id"]}
                                                label="CGST"
                                                hidden={true}
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>

                                            <Form.Item
                                                {...restField}
                                                name={[name, "cgst_rate_text"]}
                                                label="CGST"
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "cgst_amount"]}
                                                label="CGST Amt"
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                            <Form.Item {...restField} name={[name, "cgst_rate"]} hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>

                                            <Form.Item
                                                {...restField}
                                                name={[name, "sgst_id"]}
                                                label="SGST"

                                            >
                                                <Input type="text" />
                                            </Form.Item>
                                            <Form.Item {...restField} name={[name, "sgst_rate"]} hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "sgst_rate_text"]}
                                                label="SGST"
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "sgst_amount"]}
                                                label="SGST Amt"
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                            <Form.Item   {...restField} name={[name, "total_gst_amount"]} hidden={true}>
                                                <Input type="text" />
                                            </Form.Item> */}
                                            {/* <Form.Item
                                                {...restField}
                                                name={[name, "net_amount"]}
                                                label="Payable"
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item> */}
                                            <Form.Item
                                                {...restField}
                                                name={[name, "is_waiver"]}
                                                label="Waiver"
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={16} >
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'tournament_id']}
                                                label="Tournament">
                                                <Select className="text-left" allowClear={false}
                                                    disabled={!isTournamentSelectedList[index]}
                                                >
                                                    <Option value="">Select</Option>
                                                    {tournamentList.length > 0
                                                        ? tournamentList.map((tournament_list) => (
                                                            <Option
                                                                key={tournament_list.tournament_id}
                                                                value={tournament_list.tournament_id}

                                                            >
                                                                {tournament_list.tournament_name}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={2} >


                                            <Form.Item
                                                {...restField}
                                                label=" "
                                                name={[name, 'action']}

                                            >
                                                <Button
                                                    type="danger"
                                                    icon={<DeleteOutlined />}
                                                    shape="circle"
                                                    // onClick={() => remove(field.name)}
                                                    onClick={() => props.removeDetail(index)}
                                                />
                                            </Form.Item>

                                        </Col>

                                    </Row>


                                </div>

                            ))}

                        <Form.Item>
                            <Button shape='round' className='custom-button-green' onClick={() => {
                                add();
                                props.onFormCalculation();
                            }} icon={<PlusOutlined />}>
                                Add More
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
        </div>



    );
};
export default BTATournamentDetailView;